<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card>
      <v-card-title>
            <span class="title">API Settings</span>

            </v-card-title>


            <v-flex xs2 sm6>


                        <b>API Key</b> <a @click="updateKey">Update Key</a> <a @click="disableapi">Disable API</a> <v-text-field single-line outline readonly light v-model="apikey"></v-text-field>
                        <b>API IP</b> <a ref="changeipbutt" @click="changeip">Change IP</a> <a @click="resetip">Allow all</a> <v-text-field single-line outline :readonly="editableip" light ref="ipbox" v-model="apiip"></v-text-field>

            </v-flex>
</v-card>
</v-flex>
  </v-container>
</template>
<script>
import api from "@/utils/backend-api";

export default {
  components: {

  },
  data () {
    return {
      apikey: '',
      apiip: '',
      editableip: true
      }
  },
  methods: {
    changeip () {
    if (this.$refs.changeipbutt.text === "Change IP")
    {
    this.editableip = false;
    this.apiip = '';
    this.$refs.ipbox.focus();
    this.$refs.changeipbutt.text = "Update IP";
    }
    else {
    this.$refs.changeipbutt.text = "Change IP";
    this.editableip = true;
    this.updateIp();
    }

    },
    resetip () {
    api.getData("apidetails.php?action=resetip").then(res => {
       if (res.data){
         this.apikey = res.data.api.key;
         if (res.data.api.ip === "") {
         this.apiip = "API Disabled";
         }
         else {
         this.apiip = res.data.api.ip;
         }
       }
       });
    },
    disableapi () {
    api.getData("apidetails.php?action=ip&newip=").then(res => {
       if (res.data){
         this.apikey = res.data.api.key;
         if (res.data.api.ip === "") {
         this.apiip = "API Disabled";
         }
         else {
         this.apiip = res.data.api.ip;
         }
       }
       });
    },
    updateKey () {
    api.getData("apidetails.php?action=update").then(res => {
       if (res.data){
         this.apikey = res.data.api.key;
         if (res.data.api.ip === "") {
         this.apiip = "API Disabled";
         }
         else {
         this.apiip = res.data.api.ip;
         }
       }
       });
    },
    updateIp () {
    api.getData("apidetails.php?action=ip&newip=" + this.apiip).then(res => {
       if (res.data){
         this.apikey = res.data.api.key;
         if (res.data.api.ip === "") {
         this.apiip = "API Disabled";
         }
         else {
         this.apiip = res.data.api.ip;
         }
       }
       });
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
  api.getData("apidetails.php").then(res => {
     if (res.data){
       this.apikey = res.data.api.key;
       if (res.data.api.ip === "") {
       this.apiip = "API Disabled";
       }
       else {
       this.apiip = res.data.api.ip;
       }
     }
     });
  }
}
</script>



// WEBPACK FOOTER //
// APISettings.vue?08276541